import { render } from "./BlackFridaySale.vue?vue&type=template&id=385c2046&scoped=true"
import script from "./BlackFridaySale.vue?vue&type=script&lang=js"
export * from "./BlackFridaySale.vue?vue&type=script&lang=js"

import "./BlackFridaySale.vue?vue&type=style&index=0&id=385c2046&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385c2046"]])

export default __exports__